export default __webpack_public_path__ + "static/media/single-project-page-04-img01.6ebd0bc4.jpg";